import { NgModule } from '@angular/core';
import { AppSharedModule } from '../app-shared.module';
import { ComponentsModule } from '../components/components.module';
import { TipoParteLocalListaComponent } from './tipo-parte-local-lista/tipo-parte-local-lista.component';
import { TipoParteLocalRoutingModule } from './tipo-parte-local.routing';
import { TipoParteLocalService } from './tipo-parte-local.service';


@NgModule({
  imports: [
    AppSharedModule,
    ComponentsModule
  ],
  declarations: [
    TipoParteLocalListaComponent,
  ],
  exports: [
    TipoParteLocalListaComponent,
    TipoParteLocalRoutingModule
  ],
  providers: [
    TipoParteLocalService
  ]
})
export class TipoParteLocalModule { }
